import React from "react";

export const Tooltip = ({
    children,
    className = "",
    message = "",
    position = "bottom",
}) => {

    return (
        <div className={`tooltip tooltip-${position} ${className}`} data-tip={message}>
            {children}
        </div>
    )
}